import _ from 'lodash'
import fetch from '@adc/fetch'
import { gql } from '@adc/sdk'
import * as blueprint from '@adc/blueprint'

export const fetchDataForNewlyAuthenticatedUser = ({ propertyIds }) =>
  fetch
    .forAuctionGraph({
      query: gql`
        query resiEvent_fetchDataForNewlyAuthenticatedUser(
          $propertyIds: [ID!]!
        ) {
          current_user {
            user_id
            party_id
            email
            first_name
            last_name
            status

            saved_property_lookup(propertyIds: $propertyIds)
          }
        }
      `,
      variables: { propertyIds },
    })
    .then(res => res.body.data?.current_user || {})

export const fetchUserDetails = async (
  req,
  { shouldFetchAdaptiveNav = false } = {}
) =>
  fetch
    .forAuctionGraph(
      {
        query: gql`
          ${blueprint.user.fragments.buyingPreferenceFields.definition}
          ${blueprint.user.fragments.buyingPreferences.definition}
          ${blueprint.user.fragments.adaptiveNavigation.definition}

          query resiEvent_getCurrentUser($shouldFetchAdaptiveNav: Boolean!) {
            current_user {
              user_id
              party_id
              email
              first_name
              last_name
              status

              ${blueprint.user.fragments.buyingPreferences.reference}
              ${blueprint.user.fragments.adaptiveNavigation.reference} @include(if: $shouldFetchAdaptiveNav)

              saved_searches(source: ADC, sort: "createdDate,desc") {
                saved_search_id
                saved_search_name
                parameters
              }
            }
          }
        `,
        variables: {
          shouldFetchAdaptiveNav,
        },
      },
      { req }
    )
    .then(res => {
      const errors = _.get(res, 'body.errors[0]')

      // We allow partial errors so long as some information about a user was returned
      if (errors && !res.body.data?.current_user) throw errors

      const user = res.body.data.current_user

      return user
    })
